/**
 * @generated SignedSource<<c93173dea6bc8ed379cb4b9b29fb2a88>>
 * @relayHash 6af15886385d86202fbacd0200dc99eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0

import type { ConcreteRequest } from 'relay-runtime';
export type useTitleContentPropertiesForPublishedPageQuery$variables = {
  contentId?: string | null;
  status?: ReadonlyArray<string | null> | null;
};
export type useTitleContentPropertiesForPublishedPageQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly metadata: {
        readonly frontend: {
          readonly coverPictureWidth: string | null;
        } | null;
      };
      readonly pageTitleDraft: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly pageTitlePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
};
export type useTitleContentPropertiesForPublishedPageQuery = {
  response: useTitleContentPropertiesForPublishedPageQuery$data;
  variables: useTitleContentPropertiesForPublishedPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "kind": "ScalarField",
        "name": "value"
      },
      {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "number"
          }
        ]
      }
    ]
  }
],
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": "pageTitlePublished",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "page-title-property-published"
              }
            ],
            "concreteType": "PaginatedJsonContentPropertyList",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": "properties(key:\"page-title-property-published\")"
          },
          {
            "alias": "pageTitleDraft",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "page-title-property-draft"
              }
            ],
            "concreteType": "PaginatedJsonContentPropertyList",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": "properties(key:\"page-title-property-draft\")"
          },
          {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "coverPictureWidth"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useTitleContentPropertiesForPublishedPageQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTitleContentPropertiesForPublishedPageQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "6af15886385d86202fbacd0200dc99eb",
    "id": "2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0",
    "metadata": {},
    "name": "useTitleContentPropertiesForPublishedPageQuery",
    "operationKind": "query",
    "text": "query useTitleContentPropertiesForPublishedPageQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
  }
};
})();

(node as any).hash = "9a5b243b4d944acf33577dfb16711cea";

export default node;
